<div class="container" fxLayout="column" ngClass.lt-lg="lessPadding">
  <h1 class="title" fxFlex="70%">{{title}}</h1>
  <nav fxLayout="row" fxFlex="20%">
    <ul>
      <li [ngClass]="{ selected: currentView === 'portfolio' }" (click)="onPortfolioClicked()">Projects</li>
      <li [ngClass]="{ selected: currentView === 'links' }" (click)="onLinksClicked()">Links</li>
      <li><a href="https://github.com/turbidwater?tab=repositories">GitHub</a></li>
    </ul>
  </nav>
  <div fxFlex="10%">&nbsp;</div>
</div>